import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

class IntrigueComponent extends Game.src.component.BaseComponent {
    static events = {
        REEL_START: 'Intrigue.REEL_START',
        REEL_FINISH: 'Intrigue.REEL_FINISH',
    };

    protected mainGameContainerElement = null;
    protected reelsMap = null;
    protected reelId = null;

    protected tweens = [];


    constructor(config: BaseComponentConfig) {
        super(config);
    }

    onGameReady() {
        super.onGameReady();

        this.mainGameContainerElement = game.tree.findByName(
            "intrigue.wrapper_container.main_game_container"
        );

        this.reelsMap = this.createReelsMapObj();

        game.on(ReelsetComponent.events.REEL_ANTICIPATION_STARTED, ({reelId}) => {
            game.keybord.lock();
            this.reelId = reelId;
            this.showReelIntrigue(reelId);
        });

        game.on("ReelsetComponent.SPIN_FINISHED", () => {
            if (this.reelId) {
                this.hideReelIntrigue(this.reelId);
                game.keybord.unLock();
                this.reelId = null;
            }
        });
    }

    toggleUI(value) {
        game.render.layerGroups["UI"]._activeLayer.renderable = value;
        game.tree.findByName("autoplay.panel_container").renderable = value;
    }

    scaleGame(from, to, time) {
        const gmContainer = game.tree.findByName("reel_frame.wrapper_container");
        // const jackpotContainer = game.tree.findByName("jackpot.wrapper_container");
        const reelSetContainer = game.tree.findByName("reel_set.wrapper_container");

        this.removeTweens();

        const promises = [];

        promises.push(game.utils.GameUtils.playScaleToAnimation(gmContainer, {scaleFrom: from, scaleTo: to, time: time}));
        // promises.push(GameUtils.playScaleToAnimation(jackpotContainer, {scaleFrom: from, scaleTo: to, time: time}));
        promises.push(game.utils.GameUtils.playScaleToAnimation(reelSetContainer, {scaleFrom: from, scaleTo: to, time: time}));
        promises.push(game.utils.GameUtils.playScaleToAnimation(this.view, {scaleFrom: from, scaleTo: to, time: time}));

        this.tweens.push(gmContainer._tween);
        // this.tweens.push(jackpotContainer._tween);
        this.tweens.push(reelSetContainer._tween);
        //@ts-ignore
        this.tweens.push(this.view._tween);

        let pFrom = 0
        let pTo = 0;

        if (from == 1) {
            pFrom = 0;
            pTo = -130;
        } else {
            pFrom = gmContainer.position.x;
            pTo = 0;
        }


        promises.push(this.playPositionXAnimation(gmContainer, {from: pFrom, to: pTo, time: time}));
        // promises.push(this.playPositionXAnimation(jackpotContainer, {from: pFrom, to: pTo, time: time}));
        promises.push(this.playPositionXAnimation(reelSetContainer, {from: pFrom, to: pTo, time: time}));
        promises.push(this.playPositionXAnimation(this.view, {from: pFrom, to: pTo, time: time}));

        this.tweens.push(gmContainer._tween);
        // this.tweens.push(jackpotContainer._tween);
        this.tweens.push(reelSetContainer._tween);
        //@ts-ignore
        this.tweens.push(this.view._tween);

        return Promise.all(promises);
    };

    removeTweens() {
        this.tweens.forEach(tween => game.utils.removeCall(tween));
        this.tweens = [];
    }

    onChangeOrientation() {
        super.onChangeOrientation();

        game.emit(IntrigueComponent.events.REEL_FINISH, {reelId: this.reelId});
        this.onFinishIntrigue();
    }

    onFinishIntrigue() {
        this.reelId = null;

        this.toggleUI(true);
        game.keybord.unLock();

        this.removeTweens();

        this.mainGameContainerElement.options.alpha = 0;
        this.mainGameContainerElement.forceViewUpdate();

        const gmContainer = game.tree.findByName("reel_frame.wrapper_container");
        // const jackpotContainer = game.tree.findByName("jackpot.wrapper_container");
        const reelSetContainer = game.tree.findByName("reel_set.wrapper_container");

        gmContainer.options.scale = {x: 1, y: 1};
        gmContainer.options.position.x = 0;
        // jackpotContainer.options.scale = {x: 1, y: 1};
        // jackpotContainer.options.position.x = 0;
        reelSetContainer.options.scale = {x: 1, y: 1};
        reelSetContainer.options.position.x = 0;

        //@ts-ignore
        this.view.options.scale = {x: 1, y: 1};
        //@ts-ignore
        this.view.options.position.x = 0;

        //@ts-ignore
        this.view.forceViewUpdate();
        reelSetContainer.forceViewUpdate();
        gmContainer.forceViewUpdate();
        // jackpotContainer.forceViewUpdate();
    }


    showReelIntrigue(reelId) {
        game.emit(IntrigueComponent.events.REEL_START, {reelId: reelId});

        this.setPositionMainGlow(reelId);
        this.showFlowMainGame();

        this.toggleUI(false);
        this.scaleGame(1, 1.2, 2000);
    }

    hideReelIntrigue(reelId) {
        game.emit(IntrigueComponent.events.REEL_FINISH, {reelId: reelId});

        this.hideFlowMainGame();
        // this.onChangeOrientation();

        const gmContainer = game.tree.findByName("reel_frame.wrapper_container");


        this.scaleGame(gmContainer.options.scale.x, 1, 200).then(() => {
            this.onFinishIntrigue();
        });
    }

    protected async showFlowMainGame() {
        await game.utils.GameUtils.playAlphaAnimation(this.mainGameContainerElement, {from: 0, to: 1, time: 300, timeWait: 0});

        // this.onChangeOrientation();
    }

    protected async hideFlowMainGame() {
        await game.utils.GameUtils.playAlphaAnimation(this.mainGameContainerElement, {from: 1, to: 0, time: 300, timeWait: 0});

        // this.onChangeOrientation();
    }

    protected setPositionMainGlow(reelId) {
        this.mainGameContainerElement.options.position.x =
            this.reelsMap[`reel_${reelId}`].position.x * this.mainGameContainerElement.options.scale.x;
    }

    async playAlphaAnimation(object, {from, to, time, timeWait}): Promise<void> {
        return new Promise((resolve) => {
            const _tw = {count: from};

            object.options.visible = true;
            object.options.alpha = from;

            const _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    object.options.alpha = _tw.count;
                    object.forceViewUpdate();
                }
            })
                .to({count: to}, time)
                .wait(timeWait || 0)
                .call(() => {
                    object.options.visible = Boolean(to);
                    resolve();
                });

            object._tween = _tween;
        });
    }

    createReelsMapObj() {
        return {
            reel_0: game.tree.findByName("reel_0"),
            reel_1: game.tree.findByName("reel_1"),
            reel_2: game.tree.findByName("reel_2"),
        };
    }


    async playPositionXAnimation(obj, {
        from, to, time, onStart = () => {
        }, onFinish = () => {
        }
    }) {
        return new Promise((resolve) => {
            const _tw = {current: from};

            const _tween = createjs.Tween.get(_tw, {
                onChange: () => {
                    obj.options.position.x = _tw.current;
                    obj.forceViewUpdate();
                }
            })
                .call(onStart.bind(this, obj))
                .to({current: to}, time)
                .call(onFinish.bind(this, obj))
                .call(resolve);

            obj._tween = _tween;
        });
    }


    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }


}

export {IntrigueComponent};

//@ts-ignore
Game.src.component.IntrigueComponent = IntrigueComponent;
